import { isPlainObj, isStr } from "@al/aku-lc-helpers";
import { apply, applyTree } from "@al/aku-lc-dsl";
var ExprRe = /^\s*\{\{([\s\S]*)\}\}\s*$/;
export function evaluate(source, context) {
    if (isStr(source)) {
        var matched = source.match(ExprRe);
        if (!matched) {
            return source;
        }
        return apply(matched[1], context);
    }
    else if (isPlainObj(source)) {
        // TODO: 判断不是 mobx observable
        return applyTree(source, context);
    }
    return source;
}
